import React from 'react';
import { useTranslate } from '@bynder/localization';
import { ColorManipulatorView } from 'packages/pages/editor/RightSideMenu/Shots/Text/Fonts/FontColor/ColorManipulatorView';
import useOutlineFontColorManipulator from './useOutlineFontColorManipulator';

type Props = {
    creativeModel: any;
    selectedElement: any;
    disabled: boolean;
};

export const OutlineColorManipulator = ({ creativeModel, selectedElement, disabled }: Props) => {
    const core = useOutlineFontColorManipulator({ creativeModel, selectedElement });
    const { translate } = useTranslate();

    return (
        <ColorManipulatorView
            {...core}
            creativeModel={creativeModel}
            selectedElement={selectedElement}
            disabled={disabled}
            colorType="strokeColor"
            testIdPrefix="shots-text-outline-color"
            label={translate('editor.sidebar.shots.text.outline.colorpicker.label')}
        />
    );
};

export default OutlineColorManipulator;
